export default function(
  qtySelects = [...document.querySelectorAll('.js-quantity-select')],
  callback,
) {
  qtySelects.forEach(qtySelect => {
    const input = qtySelect.querySelector('input');
    const buttons = [...qtySelect.querySelectorAll('button')];

    const setInputValue = value => {
      let newValue = value;
      if (input.min && newValue < input.min) {
        newValue = input.min;
      }
      if (input.max && newValue > input.max) {
        newValue = input.max;
      }
      input.value = newValue;

      if (callback) {
        callback(input, newValue);
      }
    };

    buttons.forEach(button => {
      const { increment } = button.dataset;
      button.addEventListener('click', () => {
        const newValue = parseInt(input.value, 10) + parseInt(increment, 10);
        setInputValue(newValue);
      });
    });

    input.addEventListener('change', () => {
      setInputValue(parseInt(input.value, 10));
    });
  });
}
